import {Currency} from '../index';
import {Status} from '../reusables/status';
import {
  TicketingAdditionalItems,
  TicketingAffiliate,
  TicketingDeliveryAddress,
  TicketingEvents,
  TicketingOrderDetails,
  TicketingReservationDetails,
  TicketingSalesChannel,
  TicketingSalesOperator,
  TicketingStandardAddress,
} from './ticketing-objects';
import {DateObject} from '../reusables/date-object';
import {InvoiceOrderStatusTranslationsService} from 'src/app/shared/translations';


/**
 * Blueprint for the invoice ticket.
 */
export class InvoiceTicket {
  public id: number;
  public cancellationAddress: string;
  public type: string;
  public additionalItems: TicketingAdditionalItems;
  public affiliate: TicketingAffiliate;
  public deliveryAddress: TicketingDeliveryAddress;
  public events: Array<TicketingEvents>;
  public orderDetails: TicketingOrderDetails;
  // public orderStatus: TicketingOrderStatus;
  public reservationDetails: TicketingReservationDetails;
  public saleOperator: TicketingSalesOperator;
  public salesChannel: TicketingSalesChannel;
  public standardAddress: TicketingStandardAddress;
  public state: Status;

  public statuses: Array<any> = [
    {value: 'valid', class: 'esf-tag--success'},
    {value: 'partial', class: 'esf-tag--warning'},
    {value: 'invalid', class: 'esf-tag--alert--red'}
  ];

  constructor(data: any, private translations: InvoiceOrderStatusTranslationsService) {
    this.id = data.id;
    this.type = data.type;
    // this.cancellationAddress = data.cancellationAddress;
    // this.additionalItems = new TicketingAdditionalItems(data.additionalItems);
    this.affiliate = new TicketingAffiliate(data.affiliate);
    this.deliveryAddress = data.deliveryAddress ? new TicketingDeliveryAddress(data.deliveryAddress) : null;
    this.orderDetails = new TicketingOrderDetails(data.orderDetails, translations);
    // this.orderStatus = new TicketingOrderStatus(data.orderStatus);
    this.saleOperator = new TicketingSalesOperator(data.saleOperator);
    this.salesChannel = new TicketingSalesChannel(data.salesChannel, translations);
    this.standardAddress = data.standardAddress ? new TicketingStandardAddress(data.standardAddress) : null;

    if (data.reservationDetails) {
      this.reservationDetails = new TicketingReservationDetails(data.reservationDetails);
    }

    this.events = [];
    data.events.forEach(event => {
      this.events.push(new TicketingEvents(event));
    });

    this.state = this.getFullStatus(data);
  }

  public getFullStatus(data: any): any {
    const fullStatus = this.statuses.find(el => data.state === el.value);
    fullStatus.status = this.orderDetails.displayInvoiceNumber;
    return fullStatus ? new Status(fullStatus) : data.status;
  }

  get date(): DateObject {
    return this.orderDetails.invoiceDate;
  }

  get invoiceNumber(): string {
    return this.orderDetails.invoiceNumber;
  }

  get totalAmount(): Currency {
    return this.orderDetails.paymentDetails;
  }

  get branch(): string {
    return this.orderDetails.branch;
  }

  get translatedType(): string | string {
    return this.translations.i18nInvoice;
  }
}
